// NOMBASE — Contact FAB.
//
// The floating bottom-left button, now for SIGNED-OUT visitors only.
//
// "Contact us" moved into the profile dropdown (AppShell), which only exists
// once you are signed in. Moving it wholesale would have taken support away
// from the auth and landing screens — and this component's original note said
// reaching prospects there was the point of putting it outside AppShell. So
// the button hides when a session exists and the menu item covers that case;
// between them the route to support is never gone, and it is never offered
// twice at once.
//
// The modal itself lives in ContactModal.jsx, shared by both entry points.
import { useState } from 'react';
import { MessageSquare } from 'lucide-react';
import ContactModal from './ContactModal';
import { useApp } from '@/context/AppContext';

export default function ContactFAB() {
  const [open, setOpen] = useState(false);
  const { currentUser } = useApp();

  // Signed in ⇒ the profile menu carries it. Rendering both would put two
  // controls for one action on the same screen.
  if (currentUser) return null;

  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        className="fixed bottom-6 left-6 z-40 w-12 h-12 rounded-full bg-primary text-primary-foreground shadow-lg ring-1 ring-slate-800 hover:bg-primary/90 hover:scale-105 active:scale-95 transition-all flex items-center justify-center group"
        aria-label="Contact support"
        data-testid="contact-fab"
      >
        <MessageSquare className="w-5 h-5" strokeWidth={2.2} />
        <span className="absolute left-full ml-3 px-2.5 py-1 rounded-md bg-primary text-primary-foreground text-[11px] font-medium whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none">
          Contact us
        </span>
      </button>

      <ContactModal open={open} onClose={() => setOpen(false)} />
    </>
  );
}
